import classNames from 'classnames';
import { ReactNode, useRef } from 'react';
import useScrollToFirstInvalidField from '../../../utils/useScrollToFirstInvalidField';
import './style.scss';

export type CheckboxProps = {
  name: string;
  label: ReactNode;
  dataTestId: string;
  value: boolean;
  onChange: (value: boolean) => void;
  headline?: ReactNode;
  className?: string;
};

const Checkbox = ({ name, label, headline, value, onChange, className, dataTestId }: CheckboxProps) => {
  const checkboxRef = useRef<HTMLInputElement>(null);
  useScrollToFirstInvalidField(name, checkboxRef);

  return (
    <label className={classNames('checkbox-input', className)}>
      <input
        type="checkbox"
        onChange={e => onChange?.(e.currentTarget.checked)}
        checked={value}
        className="checkbox-input__checkbox"
        data-test-id={`${dataTestId}-checkbox`}
        ref={checkboxRef}
        data-cs-mask
        data-mf-replace="**REMOVED**"
      />
      <div className="checkbox-input__label" data-test-id={`${dataTestId}-checkbox-label`}>
        {headline && <div className="checkbox-input__headline">{headline}</div>}
        <div>{label}</div>
      </div>
    </label>
  );
};

export default Checkbox;
